export default __webpack_public_path__ + "static/media/globo-logo.65880eb0.png";